import Target_0 from './src/Checkout.jsx';shopify.extend('purchase.checkout.reductions.render-after', (...args) => Target_0(...args));